import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import ProjectInfo from './ProjectInfo';
import ClientInfo from './ClientInfo';
import Sponsor from './Sponsor';
import ScopeDetails from './ScopeDetails';
import ScopeInfo from './ScopeInfo';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import Countries from '../common/redux/countries';

//Progress
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  CREATE_PROJECT_MODEL_ACTION_CREATE,
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW
} 
from '../common/redux/constantes';


//validators
import {validateField,validateEmail, validateDates,validateDecimalNumber} from '../common/redux/validators';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = [
  'Project', 
  // 'Project Management Site',
  'Client',
  'Sponsor', 
  'Scope', 
  'Details'
  ];

class Checkout extends Component {
 

  constructor(props)
  {
    super(props);

    //Bindings
    this.handleChange=this.handleChange.bind(this);
    this.handleToggle=this.handleToggle.bind(this);
    this.handleTogglePhases=this.handleTogglePhases.bind(this);
    this.handleChangeScope=this.handleChangeScope.bind(this);
    this.saveProject=this.saveProject.bind(this);

    if(Countries[0].hasOwnProperty("code")){
      Countries.forEach( function(country) {
        country['label'] = country['name'];
        country['value'] = country['code'];
        delete country['name'];
        delete country['code'];
      });
    }
    
    //Primer estado
    let project = {};
    //Primer estado de scope
    let scope = {
      currency:1,
      budget_number:'.00',
      members:[],
      phases:[]
    };


    let members = [];
    let phases = [];
    let activeStep = 0;
    
    
    //Si está editando o viendo la info
    if(this.props.actionDialog !== CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      // this.initializeEditProject();
      project = this.props.projectEdit;

      this.props.actions.fetchMembers()
      .then(res=>{
        this.setState({members:res.members});
      })
      this.props.actions.fetchPhases()
      .then(res=>{
        this.setState({phases:res.phases});
      })

      this.props.actions.fetchScopeByProject(this.props.projectEdit.project)
      .then(res=>{
        let first_scope = res.scopes[0];
        members = this.state.members;
        phases = this.state.phases;
        
        first_scope.members.forEach((member)=>{
          let tmp = members.find(o => o.member === member.member);
          if(tmp)
            tmp.checked = true;
        })
        
        first_scope.phases.forEach((phase)=>{
          let tmp = phases.find(o => o.phase === phase.phase);
          if(tmp)
            tmp.checked = true;
        })

        this.setState({members:members, phases:phases,scope:first_scope});

      })

    }else{
      this.props.actions.fetchMembers()
      .then(res=>{
        this.setState({members:res.members});
      })


      this.props.actions.fetchPhases()
      .then(res=>{
        this.setState({phases:res.phases});
      })

      this.props.actions.getNextProjectId()
      .then(res=>{
        let user_id = localStorage.getItem("user_id");
        let current_date = moment().format("YYYY-MM-DD")
        let next_project_id = res.projects[0]?res.projects[0].project:1;
        let project_number = user_id + "-" + current_date + "-" + next_project_id;
        project = {number:project_number};
        this.setState({project:project});
      })
    }


    this.state = {
      activeStep: activeStep,
      project:project,
      scope:scope,
      members:members,
      phases:phases,
      errores:{
        project:{},
        scope:{}
      }
    };
    
  }

  getStepContent(step) {
    switch (step) {
      case 0:
        return <ProjectInfo countries={Countries} handleChange={this.handleChange} errores={this.state.errores} project={this.state.project} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      case 1:
        return <ClientInfo countries={Countries} handleChange={this.handleChange} errores={this.state.errores} project={this.state.project} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      case 2:
        return <Sponsor handleChange={this.handleChange} errores={this.state.errores} project={this.state.project} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      case 3:
        return <ScopeInfo  handleChange={this.handleChangeScope} errores={this.state.errores} scope={this.state.scope} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      case 4:
        return <ScopeDetails handleTogglePhases={this.handleTogglePhases} errores={this.state.errores} handleToggle={this.handleToggle} handleChange={this.handleChangeScope}  phases={this.state.phases} members={this.state.members} scope={this.state.scope} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      default:
        throw new Error('Unknown step');
    }
  }

  handleNext = () => {
    if(steps.length - 1 === this.state.activeStep && this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_SHOW)
    {
      //Solo puede guardar si está valido el form
      if(!this.validateForm()){
        return;
      }

      //Si es el último step hay que guardar el project. 
      this.saveProject();
    }
    else if(steps.length - 1 === this.state.activeStep)
    {
      //Por petición se hizo que si está sólo mostrando datos en el botón next se cierre la pantalla.
      this.props.onCloseAction();
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };


  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };


  handleChange(event) {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let project = this.state.project;
    project[name] = value;
    this.setState({
      project: project,
    });
    this.validateForm();
  }


  handleToggle = value => () => { 
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    let scope = this.state.scope;
    let members = this.state.members;
    if (value.checked!==true) {
      let tmp = members.find(o => o.member === value.member);
      tmp.checked = true;
      scope.members.push(value);
    } else {
      let tmp = members.find(o => o.member === value.member);
      tmp.checked = false;
      scope.members = scope.members.filter(member => member.member !== value.member);
    }
    this.setState({
      scope: scope,
      members: members
    });
  };

    handleTogglePhases = value => () => { 
      //Si sólo se está mostrando la información no cambia nada.
      if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
        return;
      let scope = this.state.scope;
      let phases = this.state.phases;
      if (value.checked!==true) {
        let tmp = phases.find(o => o.phase === value.phase);
        tmp.checked = true;
        scope.phases.push(value);
      } else {
        let tmp = phases.find(o => o.phase === value.phase);
        tmp.checked = false;
        scope.phases = scope.phases.filter(phase => phase.phase !== value.phase);
      }
      this.setState({
        scope: scope,
        phases: phases
      });
  };

   handleChangeScope(event) {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;

    let scope = this.state.scope;
    scope[name] = value;
    this.setState({
      scope: scope,
    });
    this.validateForm();
  }


  validateForm = () => {
    let errores = {
      project:{},
      scope:{}
    };

    //Todos los campos
    let project = {
      name:'',
      number:'',
      // description:'',
      ecd:'',
      kod:'',
      // company:'',
      // p_m_company_country:'',
      // p_m_company_state:'',
      // p_m_company_city:'',
      // client_company:'',
      // client_company_country:'',
      // client_company_state:'',
      // client_company_city:'',
      // sponsor_name:'',
      // sponsor_position:'',
      // sponsor_email:'',
      // sponsor_phone:''
    };
    //Todos los campos
    let scope = {
      overall_project_product:'',
      // description:'',
      budget_number:'',
      currency:'',
      // members:[],
      // phases:[]
    };

    let valido = true;


    if (this.state.project.sponsor_phone && 
      this.state.project.sponsor_phone!=="" &&
      !validateEmail(this.state.project.sponsor_email)) 
    {
      errores.project.sponsor_email= 'Not valid email';
      valido = false;
    }


    //ecd > kod
    if(!validateDates(this.state.project.ecd,this.state.project.kod, 1))
    {
      errores.project.ecd = 'Must be greather than Kick off date';
      valido = false;
    }

    //Validando los decimales del budget
    if(!validateDecimalNumber(this.state.scope.budget_number, 10))
    {
      errores.scope.budget_number = 'Incorrect decimal number';
      valido = false;
    }  

    //Validando los digitos del phone_number
    if(this.state.project.sponsor_phone && this.state.project.sponsor_phone!=="" && this.state.project.sponsor_phone.length > 20)
    {
      errores.project.sponsor_phone = 'Incorrect phone number format';
      valido = false;
    }  

    //Validando atributos almenos ingresados
    for (const attribute in project) 
    {
      if (!validateField(this.state.project[attribute])) 
      {
        errores.project[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }

    //Validando atributos almenos ingresados
    for (const attribute in scope) 
    {
      if (!validateField(this.state.scope[attribute])) 
      {
        errores.scope[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    
    this.setState({
      errores: errores,
    });
    return valido;
  }

  saveProject()
  {
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      //Create project
      this.props.actions.saveProjectAction(this.state.project,this.state.scope,CREATE_PROJECT_MODEL_ACTION_CREATE );
    }
    else
    {
      //Edit project
      this.props.actions.saveProjectAction(this.state.project,this.state.scope,CREATE_PROJECT_MODEL_ACTION_EDIT );
    }
  }

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const {savePending, fragmentContent,fragmentTitle } = this.props.home;
    const { activeStep} = this.state;
    let title = "Project Information";
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
      title =  "Create Project";
    }else if (this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_EDIT){
      title = "Update Project";
    }
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              {title}
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <div>
                  {savePending ? 
                  (
                    <CircularProgress />
                  ):(
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        {fragmentTitle}
                      </Typography>
                      <Typography variant="subtitle1">
                      {fragmentContent}
                      </Typography>
                    </React.Fragment>
                  )}
                </div>
              ) : (
                <React.Fragment>
                  {this.getStepContent(activeStep)}
                  <div className={classes.buttons}>
                    {(activeStep !== 0) && (
                      <Button
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    )}
                    {(true) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      > 
                        {activeStep === steps.length - 1 ? this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_SHOW? "Close":"Save" : "Next"}
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

Checkout.propTypes = {
  classes: PropTypes.object.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Checkout));



// WEBPACK FOOTER //
// ./src/features/home/CreateProject.js